import React from 'react';
export function SolutionSection() {
  return <section className="bg-background py-16 sm:py-24" data-id="element-539">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-540">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center gap-6" data-id="element-541">
          {/* Green divider accent */}
          <div className="flex items-center gap-3" data-id="element-542">
            <div className="h-px w-12 bg-green-300" data-id="element-543"></div>
            <span className="text-2xl" data-id="element-544">🌿</span>
            <div className="h-px w-12 bg-green-300" data-id="element-545"></div>
          </div>

          <h2 className="text-3xl sm:text-4xl font-bold text-foreground leading-tight" data-id="element-546">
            Aquí Es Donde Entra <span className="text-green-600" data-id="element-547">Trimora</span>
          </h2>

          <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl" data-id="element-548">
            Trimora está formulado para apoyar las rutas metabólicas
            relacionadas con la saciedad, el equilibrio energético y el
            bienestar digestivo — sin extremos.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full mt-4" data-id="element-549">
            <div className="bg-green-50 rounded-xl p-4 text-center border border-green-100" data-id="element-550">
              <div className="text-2xl mb-2" data-id="element-551">⚡</div>
              <p className="text-sm font-medium text-green-800" data-id="element-552">Metabolismo</p>
            </div>
            <div className="bg-green-50 rounded-xl p-4 text-center border border-green-100" data-id="element-553">
              <div className="text-2xl mb-2" data-id="element-554">🎯</div>
              <p className="text-sm font-medium text-green-800" data-id="element-555">Saciedad</p>
            </div>
            <div className="bg-green-50 rounded-xl p-4 text-center border border-green-100" data-id="element-556">
              <div className="text-2xl mb-2" data-id="element-557">🌱</div>
              <p className="text-sm font-medium text-green-800" data-id="element-558">Bienestar</p>
            </div>
          </div>

          <div className="w-full mt-6 rounded-2xl overflow-hidden shadow-md border border-green-100 max-w-2xl mx-auto" data-id="element-559">
            <img src="https://cdn.magicpatterns.com/uploads/sTGUT3mr8QwM9Wde9uHzx3/imgi_4_1765695310-imgi_3_1760553797-227_-_Funnel_Image.gif" alt="Trimora — Fórmula GLP-1+NAD+ con respaldo médico" className="w-full h-auto" unselectable="on" data-id="element-560" />
          </div>

          {/* Doctor endorsement block */}
          <div className="w-full mt-10 bg-green-50 border border-green-200 rounded-2xl overflow-hidden shadow-sm max-w-2xl mx-auto" data-id="element-561">
            <div className="flex flex-col sm:flex-row items-center gap-0" data-id="element-562">
              <div className="w-full sm:w-48 flex-shrink-0" data-id="element-563">
                <img src="https://cdn.magicpatterns.com/uploads/injaRP6KQZ1ZkQchMxK7AC/ChatGPT_Image_Feb_27,_2026,_08_39_12_PM.png" alt="Doctor recomendando Trimora" className="w-full h-56 sm:h-full object-cover object-top" data-id="element-564" />
              </div>
              <div className="flex flex-col gap-3 p-6" data-id="element-565">
                <div className="flex gap-1" data-id="element-566">
                  {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" viewBox="0 0 20 20" data-id="element-567">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-568" />
                    </svg>)}
                </div>
                <blockquote className="text-foreground text-base leading-relaxed italic" data-id="element-569">
                  "Trimora combina ingredientes con respaldo científico para
                  apoyar la saciedad y el metabolismo. Es una opción que
                  recomiendo a mis pacientes que buscan un apoyo natural."
                </blockquote>
                <div data-id="element-570">
                  <p className="font-semibold text-foreground text-sm" data-id="element-571">
                    Dr. Alejandro Ruiz
                  </p>
                  <p className="text-muted-foreground text-xs" data-id="element-572">
                    Médico especialista en Nutrición y Metabolismo
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}